<template>
  <div>
    <div class="row">
      <h1 class="col-8 primary-text">{{ title }}</h1>
      <div class="col-4 text-left "><router-link :to="{path:'StoreList',query:{isOnline:isOnline,type:type}}" class="primary-text ml-2 pointer">MORE</router-link> <i
          class="fa-solid fa-arrow-left fa-lg pointer"></i></div>
    </div>
    <div v-if="dataLoading" class="row align-items-center ">
      <div class="col-3 text-center ">
        <v-skeleton-loader
            type="avatar"
        ></v-skeleton-loader>
      </div> <div class="col-3 text-center">
      <v-skeleton-loader
          type="avatar"
      ></v-skeleton-loader>
    </div> <div class="col-3 text-center">
      <v-skeleton-loader
          type="avatar"
      ></v-skeleton-loader>
    </div> <div class="col-3 text-center">
      <v-skeleton-loader
          type="avatar"
      ></v-skeleton-loader>
    </div>
    </div>
    <div v-else-if="stores.length > 0 && stores !== undefined" class="row">

      <div class="col-12" dir="ltr">
        <carousel
            v-if="stores.length >0"
            :autoplay="false"
            :autoplayTimeout="7000"
            :dots="false"
            :margin="5"
            :nav="false"
            :responsive="{0:{items:4},600:{items:5},700:{items:6},785:{items:4},900:{items:5},1200:{items:6}}"

            :rtl="true">
          <div v-for="item in stores" :key="item.VendorID" >
            <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}" >
            <v-avatar  :size="$vuetify.breakpoint.xs ? 65 : 80">
              <img :src="$replaceHttps(item.PictureLogoUrl)"  alt="لوگو فروشگاه"/></v-avatar>
            </router-link>
          </div>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from "vue-owl-carousel";

export default {
  name: "Stores",
  props: ['stores', 'title', 'dataLoading','isOnline','type'],

  components: {
    carousel,
  },
  data: () => ({
  }),
  mounted() {
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
  }
}</script>

<style scoped>

</style>
